module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-form"
  }, [_c('h4', [_vm._v("联系人信息")]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.result,
      "label-width": "84px"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReadOnly),
      expression: "!isReadOnly"
    }]
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "主联系人",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.result.C_Name),
      callback: function($$v) {
        _vm.$set(_vm.result, "C_Name", $$v)
      },
      expression: "result.C_Name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系人电话",
      "required": "",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.result.C_Tel),
      callback: function($$v) {
        _vm.$set(_vm.result, "C_Tel", $$v)
      },
      expression: "result.C_Tel"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系地址",
      "required": ""
    }
  }, [_c('el-select', {
    staticClass: "widthLen",
    attrs: {
      "placeholder": "选择省",
      "filterable": "",
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.selfChangeProvince
    },
    model: {
      value: (_vm.result.ProvId),
      callback: function($$v) {
        _vm.$set(_vm.result, "ProvId", $$v)
      },
      expression: "result.ProvId"
    }
  }, _vm._l((_vm.provinceList), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  })), _vm._v(" "), _c('el-select', {
    staticClass: "widthLen",
    attrs: {
      "placeholder": "选择市",
      "filterable": "",
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.selfChangeCity
    },
    model: {
      value: (_vm.result.CityId),
      callback: function($$v) {
        _vm.$set(_vm.result, "CityId", $$v)
      },
      expression: "result.CityId"
    }
  }, _vm._l((_vm.cityList), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  })), _vm._v(" "), _c('el-select', {
    staticClass: "widthLen",
    attrs: {
      "placeholder": "选择区",
      "filterable": "",
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.selfChangeArea
    },
    model: {
      value: (_vm.result.AreaId),
      callback: function($$v) {
        _vm.$set(_vm.result, "AreaId", $$v)
      },
      expression: "result.AreaId"
    }
  }, _vm._l((_vm.areaList), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "详细地址",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.result.Address),
      callback: function($$v) {
        _vm.$set(_vm.result, "Address", $$v)
      },
      expression: "result.Address"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "viewImgPos",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系人身份证",
      "required": _vm.isRequired
    }
  }, [_c('ul', {
    staticClass: "img-list"
  }, _vm._l((_vm.result.C_IDNumber_Drawing), function(img, index) {
    return _c('li', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": img.Url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.showImgView(img)
        }
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isReadOnly),
        expression: "!isReadOnly"
      }],
      staticClass: "el-icon-delete2",
      on: {
        "click": function($event) {
          _vm.delC_Drawing(_vm.result.C_IDNumber_Drawing, index)
        }
      }
    })])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReadOnly),
      expression: "!isReadOnly"
    }],
    staticClass: "container",
    attrs: {
      "id": _vm.lxrsfzContainerId
    }
  }, [_c('el-button', {
    staticClass: "upload-btn",
    attrs: {
      "id": _vm.lxrsfzBtnId,
      "size": "small",
      "icon": "plus"
    }
  })], 1)])], 1)], 1), _vm._v(" "), (_vm.isReadOnly) ? _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "主联系人："
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.result.C_Name) + "\n                    ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系人电话：",
      "label-width": "100px"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.result.C_Tel) + "\n                    ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人地址：",
      "label-width": "100px"
    }
  }, [(_vm.showData.AreaName !== '') ? _c('span', [_vm._v(" " + _vm._s(_vm.showData.ProvName) + "-" + _vm._s(_vm.showData.CityName) + "-" + _vm._s(_vm.showData.AreaName))]) : _c('span', [_vm._v(" " + _vm._s(_vm.showData.ProvName) + "-" + _vm._s(_vm.showData.CityName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "详细地址："
    }
  }, [_vm._v("\n                " + _vm._s(_vm.result.Address) + "\n            ")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "viewImgPos",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系人身份证：",
      "label-width": "120px"
    }
  }, [_c('ul', {
    staticClass: "img-list"
  }, _vm._l((_vm.result.C_IDNumber_Drawing), function(img, index) {
    return _c('li', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": img.Url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.showImgView(img)
        }
      }
    })])])
  }))])], 1)], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-141e9ade!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CRMAgentManage/components/agent-contactnew/index.vue
// module id = 1390
// module chunks = 1